'use strict';

var util = require('../util/property-util');

module.exports = /*@ngInject*/ ["$location", "$state", "$timeout", "$log", "$filter", function ($location, $state, $timeout, $log, $filter) {

    var factory = {};
    var reloadPromise;

    /**
     * Saves a key-value pair to the stateparams
     * @param key       the key is the name that is used to save the pair to the stateparams
     * @param value     the value to save
     */
    factory.save = function (key, value) {
        $state.current.reloadOnSearch = false;

        // stringify if the value is an array
        if (value instanceof Array) {
            value = JSON.stringify(value);
        }
        // the reloadPromise can still be waiting to be executed, so we cancel it just to be sure
        if (util.isDefined(reloadPromise)) {
            $timeout.cancel(reloadPromise);
        }
        $location.search(key, value);

        reloadPromise = $timeout(function () {
            $state.current.reloadOnSearch = undefined;
        });
    };
    /**
     * Gets the value for a key from the stateparams
     * @param key           name of the key
     * @param isArray       set to true if the value is an array (additional parsing)
     * @param jsonParse     set to true if you want the value to be parsed to json
     * @returns {*}         the value of the key
     */
    factory.get = function (key, isArray, jsonParse) {
        var value = $location.search()[key];
        if (util.isDefined(value)) {
            if (jsonParse || isArray) {
                return JSON.parse(value);
            } else {
                return value;
            }
        } else {
            //$log.warn("Parameter\"", key, "\"is not defined");
        }
    };

    /**
     * Deletes the key from the stateparams
     * @param key           name of the key
     */
    factory.delete = function (key) {
        var value = $location.search()[key];
        if (util.isDefined(value)) {
            value = $location.search(key, null);
        }
    };

    /**
     * Generates and saves a list of values for the specified property of every element in the array
     * @param key       the name of the key
     * @param array     the array that contains elements (every element should have the provided property)
     * @param property  name of the property to save
     */
    factory.saveListOfProperties = function (key, array, property) {
        var tmpArray = util.getListOfProperties(array, property);
        factory.save(key, tmpArray);
    };

    /**
     * Saves a timestamp to the stateparams
     * @param key   the name of the key to save to date to
     * @param date
     */
    factory.saveTimestamp = function (key, date) {
        var value = $filter('date')(date, 'yyyy-MM-dd-HH:mm');
        factory.save(key, value);
    };

    /**
     * Gets a timestamp from the stateparams
     * @param key   the name of the key that contains the date
     * @returns {*} timestamp object
     */
    factory.getTimestamp = function (key) {
        return factory.get(key, false, false);
    };

    /**
     * Saves a timestamp including seconds to the stateparams
     * @param key   the name of the key to save to date to
     * @param date
     */
    factory.saveTimestampWithSeconds = function (key, date) {
        var value = $filter('date')(date, 'yyyy-MM-dd-HH:mm:ss');
        factory.save(key, value);
    };

    /**
     * Saves a date to the stateparams
     * @param key   the name of the key to save to date to
     * @param date  date value
     */
    factory.saveDate = function (key, date) {
        var value = $filter('date')(date, 'yyyy-MM-dd');
        factory.save(key, value);
    };

    /**
     * Gets a date from the stateparams
     * @param key   the name of the key that contains the date
     * @returns {*} date object
     */
    factory.getDate = function (key) {
        var value = factory.get(key, false, false);
        if (util.isDefined(value)) {
            value = new Date(value);
        }
        return value;
    };
    /**
     * Returns the current parameters that are set in the URL as a json object
     * @returns {*|Object}
     */
    factory.getCurrentParameters = function () {
        return $location.search();
    };
    return factory;
}];